import {Component} from "@angular/core";
import {AzModalConfig, AzModalRef, ModalBaseComponent} from "@azigrene/components";

@Component({
  selector: 'app-az-alert-modal',
  templateUrl: './az-alert-modal.component.html'
})
export class AzAlertModalComponent extends ModalBaseComponent {
  mode: string;
  text: string;
  accept: () => void;
  constructor(private ref: AzModalRef, private config: AzModalConfig) {
    super(config, ref);
    if (!config.data.text) {
      this.ref.close(false);
    }

    this.mode = config.data.mode;
    this.text = config.data.text;
    this.accept = config.data.accept;
  }
}
